var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_410_345)","key":0},React.createElement("path",{"d":"M15.1256 13.5823C15.9155 12.483 16.3791 11.1373 16.3791 9.68954C16.3791 5.99485 13.3842 3 9.68954 3C5.99485 3 3 5.99485 3 9.68954C3 13.3842 5.99485 16.3791 9.68954 16.3791C11.1373 16.3791 12.483 15.9155 13.5823 15.1256L19.4666 21L21 19.4666L15.1256 13.5823ZM9.68954 14.3208C7.12693 14.3208 5.05832 12.2521 5.05832 9.68954C5.05832 7.12693 7.12693 5.05832 9.68954 5.05832C12.2521 5.05832 14.3208 7.12693 14.3208 9.68954C14.3208 12.2521 12.2521 14.3208 9.68954 14.3208Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_410_345"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

SearchIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
